import React, { useEffect, useState } from 'react';
import Messages from '../../constants/Messages';
import FormField from '../../containers/form-field/form-field';
import Input from '../../components/form-elements/input';
import Button from '../../components/form-elements/button';
import Loader from '../../components/loader/loader';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ErrorUtils from '../../utilities/error-utils';
import LoginValidations from '../../utilities/login-validations';
import AppRoutes from '../../constants/AppRoutes';
import { useNavigate } from 'react-router-dom';
import AuthenticationService from '../../services/authentication-service';
import Modal from '../../containers/modals/modal';
import { useAuth } from '../../hooks/useAuth';

const ForgotPassword = () => {
    const [loader, setLoader] = useState(false);
    const [modal, setModal] = useState(false);
    const [email, setEmail] = useState();
    const [validationErrors, setValidationErrors] = useState({
        email : null
    });
    const navigate = useNavigate();
    const { authLogout } = useAuth();

    

    /** ---------------------------------
     * Method : Email Input Change
     */
    const onEmailChange = (e) => {
        setEmail(e.target.value);
    };

    /** ---------------------------------
     * Method : Send Email
     * 
     */
    const sendEmail = async () => {
        // client side validation
        const validateEmailErrors = LoginValidations.validateEmail(email);
        setValidationErrors({
            email : validateEmailErrors
        });
        
        if(validateEmailErrors == null){
            setLoader(true);
            try{
                const isSuccess = await AuthenticationService.forgotPasswordSendEmail({
                    email : email
                });
                if(isSuccess) {
                    setModal(true);
                }
            } catch (error) {
                if(error.code === Messages.ERROR_CODES.INVALID_JWT.code) {
                    authLogout();
                    navigate(AppRoutes.LOGIN);
                } else {
                    toast.error(error.message);
                }
            }
            setLoader(false);
        }
    };

    /** ---------------------------------
     * Method : backToLogin
     * Desc : Navigate to Login page
     */
    const backToLogin = () => {
        navigate(AppRoutes.LOGIN);
    }

    return (
        <>
            <div className="mx-auto max-w-lg p-8 pt-20 bg-white h-screen">
                <h1 className='text-3xl font-bold'>{Messages.LOGIN.TITLE}</h1>
                <h1>{Messages.FORGOT_PASSWORD.PAGE_TITLE}</h1>

                <div className='mt-10'>
                    <FormField label = {Messages.LOGIN.FORM_FIELDS.EMAIL.LABEL} labelClass = "text-sm" error = {validationErrors.email}>
                        <Input type = "email" onChange = {onEmailChange}/>
                    </FormField>
                    <FormField>
                        <Button size = "full" onClick = {sendEmail}>{Messages.FORGOT_PASSWORD.FORM_FIELDS.SEND_EMAIL}</Button>
                    </FormField>
                </div>

                <a className='text-xs' onClick={backToLogin}>{Messages.FORGOT_PASSWORD.BACK_TO_LOGIN}</a>

                <Loader show = {loader} fullPage = {true}/>
                <ToastContainer/>
                <Modal 
                    show = {modal} 
                    title = {Messages.FORGOT_PASSWORD.MODAL.EMAIL_SENT.TITLE}
                    actionLabel = {Messages.FORGOT_PASSWORD.MODAL.EMAIL_SENT.ACTIONS.BACK_TO_LOGIN}
                    actionCallback = {backToLogin}
                >
                    {Messages.FORGOT_PASSWORD.MODAL.EMAIL_SENT.MESSAGE}
                </Modal>
            </div>
        </>
    )
}
export default ForgotPassword;